"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
/**
 *
 * @category component
 */
const ButtonContactUs = ({ title, body, email }) => (react_1.default.createElement(Button_1.default, { onClick: () => (window.location.href = `mailto:${email}?subject=${title}&body=${body}`) }, "Contact us"));
exports.default = ButtonContactUs;
